import { BaseApiService } from '@/shared/api/BaseApiService';

export interface CustomRoleDTO {
  id: string;
  name: string;
  permissions: string[];
  description?: string | null;
  clinicScope?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedCustomRolesResult {
  items: CustomRoleDTO[];
  nextCursor?: string;
}

export interface CreateCustomRoleInput {
  name: string;
  permissions: string[];
  description?: string;
}

export interface UpdateCustomRoleInput {
  permissions?: string[];
  description?: string;
}

export class CustomRolesService extends BaseApiService {
  protected readonly resourcePath = 'custom-roles';

  async list(cursor?: string, limit?: number): Promise<PaginatedCustomRolesResult> {
    return this.get('', { params: { cursor, limit } });
  }

  async create(input: CreateCustomRoleInput): Promise<CustomRoleDTO> {
    return this.post('', input);
  }

  async update(id: string, input: UpdateCustomRoleInput): Promise<CustomRoleDTO> {
    return this.put(`/${id}`, input);
  }

  async remove(id: string): Promise<{ success: boolean }> {
    return super.delete(`/${id}`);
  }
}
